<app-navigation-layout [hideHeader]='true'>
  <span main-container>
    <app-ticket-advanced-configurator></app-ticket-advanced-configurator>
  </span>
  <span menu-container>
    <app-booking-basket-simple-view></app-booking-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBackwardClick()" (forwardClick)="onForwardClick()" [forwardError]="">
    </app-backward-forward>
  </span>
</app-navigation-layout>
